const fileUpload = {
  'file-upload.upload': 'رفع ملف',
  'file-upload.uploading': 'رفع ملف...',
  'file-upload.success': 'رفع ملف بنجاح',
  'file-upload.error': 'رفع ملف بنجاح',
  'file-upload.error.message': 'رفع ملف بنجاح',
  'file-upload.formatHint': 'Supported formats: {accept}',
  'file-upload.sizeHint.max': 'File size must be less than {maxSize}Mb',
  'file-upload.countLimit': 'Maximum number of files: {maxCount}',
  'file-upload.singleFile': 'Can only upload one file',
};

export default fileUpload;
